module.exports = __webpack_public_path__ + "static/img/empty-00.10ada5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-00.png
// module id = 110
// module chunks = 7